/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";

import USER_DATA_RESPONSE_INTERFACE from "@Services/Application/Responses/User/Data";


import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";

import USER_INTERFACE from "@Services/Application/Interfaces/Users/User";


import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";


import REST_API_REQUEST from "@Services/Utilities/Requests";


export const GET_USER_DATA_API_REQUEST = async (
    USER_ID: string,
    USER_REST_API_URL: string,
    REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE | null = null
): Promise<USER_DATA_RESPONSE_INTERFACE> => {


    if (!USER_ID || !REQUEST_TOKEN || !USER_REST_API_URL) {
        return {
            ERROR: {
                CODE: 400,
                MESSAGE: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"
            }
        };
    }


    const USER_REQUEST_DATA = {UserId: USER_ID, ContentType: "G"};

    try {

        const USER_DATA_RESPONSE = await REST_API_REQUEST(
            USER_REST_API_URL, USER_REQUEST_DATA, REQUEST_TOKEN
        );

        if (USER_DATA_RESPONSE.status === 200) {

            const USER_RESPONSE_CONTENT: USER_INTERFACE = await USER_DATA_RESPONSE.json();

            return {
                USER: USER_RESPONSE_CONTENT,
                TOKEN: prepareRestApiRequestToken(USER_DATA_RESPONSE.headers)
            };

        } else {

            const ERROR_RESPONSE_CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await USER_DATA_RESPONSE.json();

            return {
                ERROR: {
                    CODE: USER_DATA_RESPONSE.status,
                    MESSAGE: ERROR_RESPONSE_CONTENT.UserMessage
                }
            }

        }

    } catch (e) {
        return {
            ERROR: {
                CODE: 599,
                MESSAGE: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"
            }
        }
    }

};


export default GET_USER_DATA_API_REQUEST;
